const domain = 'https://www.holidayextras.com'
module.exports = {
  tripapp: {
    path: `${domain}/static/`
  },
  auth: {
    login: `${domain}/dock-yard/tripapp-rails/users/sign_in.json`,
    url: `${domain}/dock-yard/traveller-api/graphql`,
    logout: `${domain}/dock-yard/tripapp-rails/users/sign_out.json?_method=delete`,
    query: `fragment vehicle on Vehicle {
        id
        label
        manufacturer
        model
        colour
        registration
    }

    fragment telephone on Telephone {
        id
        label
        number
    }

    fragment address on Address {
        id
        label
        addressLines
        locality
        region
        postalCode
        country
    }

    fragment trip on Trip {
        id
        lag
        to
        from
        departureShortName
        destinationShortName
        bookings {
            agent
            bookingRef
            unprefixedBookingRef
            bookingStatus
            manageBookingLink
            products {
                primary {
                    code
                    type
                    normalisedType
                    content {
                        name
                    }
                }
            }
        }
        recommendations {
            index
            productType
            normalisedProductType
            action {
                type
                value
            }
            content {
                heading
                image
                summary
            }
        }
    }

    fragment card on Card {
        id
        label
        paymentRef
        # cardHolderName
        lastFourDigits
        expiryDate
        issuer
        isCredit
    }

    fragment debit on DirectDebit {
        id
        label
        paymentRef
        agentCode
        accountHolderName
        lastFourDigits
    }

    fragment voucher on Voucher {
      id
      label
      bookingRef
      totalValue
      remainingValue
      currency
      nonFlex
      expires
      created
      productType
      agentCode
      refundValue
      redemptions {
        bookingRef
      }
      refunds {
        value
      }
      cancellationFeeRedeemable
      redemptionConditions {
        agentGroupCode
        productAuthority
      }
    }

    query {
        getTraveller {
            userExtId
            vouchers {
              active {
                ...voucher
              }
              expired {
                ...voucher
              }
              refunded {
                ...voucher
              }
            }
            profile {
            title
            givenName
            familyName
            email
            telephones {
                preferred {
                ...telephone
                }
                other {
                ...telephone
                }
            }
            vehicles {
                preferred {
                ...vehicle
                }
                other {
                ...vehicle
                }
            }
            addresses {
                preferred {
                ...address
                }
                other {
                ...address
                }
            }
            paymentMethods {
                cards {
                isPreferredPaymentMethod
                preferred {
                    ...card
                }
                other {
                    ...card
                }
                }
                directDebits {
                isPreferredPaymentMethod
                preferred {
                    ...debit
                }
                other {
                    ...debit
                }
                }
            }
            tripappMetadata {
                autoGeneratedPassword
                hasCompleteBookings
                railsUserID
            }
            }
            upcomingTrips {
            ...trip
            }
            pastTrips {
            ...trip
            }
        }
    }`
  },
  userExists: {
    url: `${domain}/dock-yard/traveller-api/graphql`,
    query: {
      query: 'query UserExists($email: String!){hasAccount(email: $email)}',
      variables: {
        email: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./shared/config/authentication/uk/index.js